import React from 'react'
import { Helmet } from 'react-helmet-async'

export const ForgotPasswordPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Forgot Password - Jewelry Inventory Tracker</title>
      </Helmet>
      <div className="text-center">
        <h1 className="text-2xl font-bold">Forgot Password</h1>
        <p>Password reset page coming soon...</p>
      </div>
    </>
  )
}